'use strict';

module.exports = {
    tooltipRun: function () {
        $('[data-toggle="tooltip"]').tooltip();
    }
};
